import ParfasLogo from "../assets/parfas-logo.png";
import ResureLogo from "../assets/resure-logo.png";
import KnowioLogo from "../assets/knowio-logo.png";
import PortalLogo from "../assets/portal-logo.png";
import TowerLogo from "../assets/tower-logo.png";
import ctsgLogo from "../assets/solar-logo.png";
import cscLogo from "../assets/csc-logo.png";
import siteGuardLogo from "../assets/siteguard-logo.png";
import siteGuardianLogo from "../assets/siteguardian-logo.png";
import crimeGuardLogo from "../assets/crimeguard-logo.png";
import redLogo from "../assets/red-logo.png";

export const logoMap = {
    "EyeSpyFX": KnowioLogo,
    "PARFAS": ParfasLogo,
    "RE:SURE": ResureLogo,
    "SOLO": ResureLogo,
    "PORTAL_SECURITY": PortalLogo,
    "CPS": ResureLogo,
    "EES": ResureLogo,
    "KNOWIO": KnowioLogo,
    "CTSG": ctsgLogo,
    "Tower Security": TowerLogo,
    "CSC": cscLogo,
    "SiteGuard": siteGuardLogo,
    "Site Guardian": siteGuardianLogo,
    "CrimeGuard": crimeGuardLogo,
    "RED CCTV": redLogo
};